export default __webpack_public_path__ + "static/favicon-196x196-db4f5751cb69731c46fd8193bd53fd75.png";